import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'cloudspace',
  title: '云空间',
  routes: [
    { path: '/cloud-space', name: 'cloud', component: () => import('./CloudSpaceView.vue'), meta: {} },
  ],
} satisfies FeatureModule
